import React, { Component } from "react"
import PropTypes from "prop-types"

import {
    federalRegions,
    stateRegions,
    localRegions,
    federalAndStates,
    usRegions,
    euRegions,
} from "shared/imports/regionConstants"

import { MAX_BILL_SEARCHIFY_SELECTIONS } from "shared/search/constants"

import {
    textGenericFilter,
    enumSingleGenericFilter,
    datePickerGenericFilter,
    // sorting functions
    enumValueSort,
} from "shared/search/containers/Filter/Filters"
import {
    enumGenericFilter,
    toggleGenericFilter,
    searchifySelectGenericFilter,
    multiGenericFilter,
} from "shared/search/containers/Filter/FilterCreators"

import {
    OfficialFilterableListView,
    BillFilterableListView,
    DocumentFilterableListView,
    // SupporterFilterableListView,
    // NoteFilterableListView,
    // GrassrootsActionFilterableListView,
    // EventFilterableListView,
    // VoteFilterableListView,
    AmendmentFilterableListView,
    // CommitteeFilterableListView,
    // CaucusFilterableListView,
    LegislatorSearchifyFLV,
    StateSearchifyFLV,
    DistrictSearchifyFLV,
    UpperLDSearchifyFLV,
    LowerLDSearchifyFLV,
    CountySearchifyFLV,
    MunicipalitySearchifyFLV,
    CountrySearchifyFLV,
    CustomRegionSearchifyFLV,
    BulkEmailFilterableListView,
    LegislativeSessionSearchifyFLV,
    CampaignSearchifyFLV,
    WitnessSearchifyFLV,
    StafferTitleSearchifyFLV,
    IssueSearchifyFLV,
    VoteResultFilterableListView,
    LegislatorSearchifyWithoutCampaignFinanceFLV,
} from "shared/search/containers/FilterableListView/FilterableListViews"

import {
    BillSelect,
    AmendmentSelect,
    LegislatorSelect,
    IssueSelect,
    LegislatorSelectWithoutCampaignFinance,
    VoteResultSelect,
} from "app/static/frontend/selects/containers/PieSelect"

export class VoteBillFilter extends Component {
    static get defaultProps() {
        return {
            filterComponent: searchifySelectGenericFilter,
            uniqueFilterId: "voteBillFilter",
            filterKey: "about_bill",
            dataTypeLabel: "Bills",
            searchifyFLV: BillFilterableListView,
            selectComponent: BillSelect,
            maxSearchifySelections: MAX_BILL_SEARCHIFY_SELECTIONS,
        }
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

export class VoteAmendmentFilter extends Component {
    static get defaultProps() {
        return {
            filterComponent: searchifySelectGenericFilter,
            uniqueFilterId: "voteAmendmentFilter",
            filterKey: "about_amendment",
            dataTypeLabel: "Amendments",
            searchifyFLV: AmendmentFilterableListView,
            selectComponent: AmendmentSelect,
            regions: federalRegions,
        }
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

export class VoteChamberFilter extends Component {
    static defaultProps = {
        filterComponent: enumGenericFilter,
        uniqueFilterId: "voteChamberFilter",
        filterKey: "chamber__in",
        enumItems: DjangIO.app.models.CongressChamber.region_supported_items(),
        displayLabel: "Chamber",
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

export class VotePersonVotedWayFilter extends Component {
    static get defaultProps() {
        const uniqueFilterId = "votePersonVotedWayFilter"
        const selectId = `${uniqueFilterId}MultiSelect`
        const enumId = `${uniqueFilterId}MultiEnum`
        const toggleId = `${uniqueFilterId}MultiToggle`

        const mapToggleToFilterKey = {
            true: "or",
            false: "and",
        }

        const resultTypes = DjangIO.app.vote.models.VoteResultType.region_supported_items().filter(
            (item) =>
                ![
                    DjangIO.app.vote.models.VoteResultType.unknown.value,
                    DjangIO.app.vote.models.VoteResultType.present.value,
                ].includes(item.value),
        )

        const mapEnumToFilterKey = resultTypes.reduce((collection, val) => {
            collection[val.value] = val.key
            return collection
        }, {})

        // we haven't flowed DjangIO yet, so in the meantime we'll ignore flow here.
        // keys can definitely be coerced to strings.
        const allFilterKeys = Object.values(mapEnumToFilterKey)
            .map((voteResult) => {
                return Object.values(mapToggleToFilterKey).map((toggle) => `${voteResult}_voters_${toggle}`)
            })
            .reduce((arr, val) => [...arr, ...val])

        const select = class SelectFilter extends Component {
            static defaultProps = {
                filterComponent: searchifySelectGenericFilter,
                uniqueFilterId: selectId,
                filterKey: "",
                dataTypeLabel: "Legislators",
                searchifyFLV: LegislatorSearchifyWithoutCampaignFinanceFLV,
                selectComponent: LegislatorSelectWithoutCampaignFinance,
            }

            render() {
                const FilterComponent = this.props.filterComponent
                return <FilterComponent {...this.props} />
            }
        }

        const toggle = class ToggleFilter extends Component {
            static defaultProps = {
                filterComponent: toggleGenericFilter,
                uniqueFilterId: toggleId,
                filterKey: "",
                initialValue: "true",
                trueText: "ANY",
                falseText: "ALL",
            }

            render() {
                const FilterComponent = this.props.filterComponent
                return <FilterComponent {...this.props} />
            }
        }

        const enums = class EnumFilter extends Component {
            static defaultProps = {
                filterComponent: enumSingleGenericFilter,
                uniqueFilterId: enumId,
                filterKey: "",
                displayLabel: "Desired Result",
                enumItems: resultTypes,
                initialValue: DjangIO.app.vote.models.VoteResultType.yea.value.toString(),
                sortBy: enumValueSort,
            }

            render() {
                const FilterComponent = this.props.filterComponent
                return <FilterComponent {...this.props} />
            }
        }

        return {
            filterComponent: multiGenericFilter,
            displayLabel: "Voting Members",
            uniqueFilterId,
            subfilters: [select, toggle, enums],
            allFilterKeys,
            computeFilterKeyFromSubfilters: (filters) => {
                const voteResult = filters.get(enumId)
                const toggleResult = filters.get(toggleId)
                if (voteResult && toggleResult) {
                    return `${mapEnumToFilterKey[voteResult]}_voters_${mapToggleToFilterKey[toggleResult]}`
                }
                return ""
            },
            computeFilterValueFromSubfilters: (filters) => filters.get(selectId, undefined),
            computeSubfilterValuesFromParent: (filterKey, value) => ({
                [selectId]: value,
                [enumId]: Object.keys(mapEnumToFilterKey).find(
                    (key) => mapEnumToFilterKey[key] === filterKey.split("_")[0],
                ),
                [toggleId]: Object.keys(mapToggleToFilterKey).find(
                    (key) => mapToggleToFilterKey[key] === filterKey.split("_")[2],
                ),
            }),
            serializationKey: searchifySelectGenericFilter.defaultProps.serializationKey,
        }
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

export class VotePersonDirectionPercentPartyFilter extends Component {
    static get defaultProps() {
        const uniqueFilterId = "votePersonDirectionPercentPartyFilter"
        const inputId = `${uniqueFilterId}MultiNumberInput`
        const toggleId = `${uniqueFilterId}MultiToggle`
        const selectId = `${uniqueFilterId}MultiSelect`
        const enumId = `${uniqueFilterId}MultiEnum`

        const mapToggleToFilterKey = {
            true: "with",
            false: "against",
        }

        const mapEnumToFilterKey = DjangIO.app.vote.models.VoterGroup.region_supported_items().reduce(
            (collection, val) => {
                collection[val.value] = val.key
                return collection
            },
            {},
        )

        const allFilterKeys = Object.values(mapEnumToFilterKey)
            .map((body) => {
                return Object.values(mapToggleToFilterKey).map((position) => `${position}_percent_${body}`)
            })
            .reduce((arr, val) => [...arr, ...val])

        const select = class SelectFilter extends Component {
            static defaultProps = {
                filterComponent: searchifySelectGenericFilter,
                uniqueFilterId: selectId,
                filterKey: "",
                dataTypeLabel: "Legislator",
                searchifyFLV: LegislatorSearchifyFLV,
                selectComponent: LegislatorSelect,
                multi: false,
            }

            render() {
                const FilterComponent = this.props.filterComponent
                return <FilterComponent {...this.props} />
            }
        }

        const input = class InputFilter extends Component {
            static defaultProps = {
                filterComponent: textGenericFilter,
                uniqueFilterId: inputId,
                filterKey: "",
                placeholderText: "Percent...",
                keyboardType: "numeric",
                displayLabel: "Percent",
            }

            render() {
                const FilterComponent = this.props.filterComponent
                return <FilterComponent {...this.props} />
            }
        }

        const toggle = class ToggleFilter extends Component {
            static defaultProps = {
                filterComponent: toggleGenericFilter,
                uniqueFilterId: toggleId,
                filterKey: "",
                initialValue: "true",
                trueText: "WITH",
                falseText: "AGAINST",
            }

            render() {
                const FilterComponent = this.props.filterComponent
                return <FilterComponent {...this.props} />
            }
        }

        const enums = class EnumFilter extends Component {
            static defaultProps = {
                filterComponent: enumSingleGenericFilter,
                uniqueFilterId: enumId,
                filterKey: "",
                displayLabel: "Of",
                enumItems: DjangIO.app.vote.models.VoterGroup.region_supported_items(),
                initialValue: DjangIO.app.vote.models.VoterGroup.chamber.value.toString(),
                sortBy: enumValueSort,
            }

            render() {
                const FilterComponent = this.props.filterComponent
                return <FilterComponent {...this.props} />
            }
        }

        return {
            filterComponent: multiGenericFilter,
            displayLabel: "Compare Member",
            uniqueFilterId,
            subfilters: [select, toggle, input, enums],
            allFilterKeys,
            computeFilterKeyFromSubfilters: (filters) => {
                const position = filters.get(toggleId)
                const party = filters.get(enumId)
                if (position && party) {
                    return `${mapToggleToFilterKey[position]}_percent_${mapEnumToFilterKey[party]}`
                }
                return ""
            },
            computeFilterValueFromSubfilters: (filters) => {
                const person = filters.get(selectId)
                const percent = filters.get(inputId)
                const position = filters.get(toggleId)
                const party = filters.get(enumId)

                if (person && percent && position && party) {
                    return `${JSON.parse(person).addedIds[0]},${percent}`
                }

                return undefined
            },
            computeSubfilterValuesFromParent: (filterKey, value) => ({
                [inputId]: value.split(",")[1],
                [selectId]: JSON.stringify({
                    addedIds: [Number(value.split(",")[0])],
                    deletedIds: [],
                    querysetList: [],
                    searchifyCount: 1,
                }),
                [enumId]: Object.keys(mapEnumToFilterKey).find(
                    (key) => mapEnumToFilterKey[key] === filterKey.split("_")[2],
                ),
                [toggleId]: Object.keys(mapToggleToFilterKey).find(
                    (key) => mapToggleToFilterKey[key] === filterKey.split("_")[0],
                ),
            }),
            serializationKey: textGenericFilter.defaultProps.serializationKey,
        }
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

export class VoteResultFilter extends Component {
    static defaultProps = {
        filterComponent: enumGenericFilter,
        uniqueFilterId: "voteResultFilter",
        filterKey: "result_type__in",
        enumItems: DjangIO.app.vote.models.VoteResultType.region_supported_items().filter(
            (item) =>
                ![
                    DjangIO.app.vote.models.VoteResultType.missed.value,
                    DjangIO.app.vote.models.VoteResultType.present.value,
                ].includes(item.value),
        ),
        sortBy: enumValueSort,
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

export class VoteTypeFilter extends Component {
    static defaultProps = {
        filterComponent: enumGenericFilter,
        uniqueFilterId: "voteTypeFilter",
        filterKey: "category__in",
        enumItems: DjangIO.app.vote.models.VoteCategory.region_supported_items(),
        enumGroups: DjangIO.app.vote.models.VoteCategory.filter_groups,
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

export class VoteStateVoteTypeFilter extends Component {
    static defaultProps = {
        filterComponent: toggleGenericFilter,
        uniqueFilterId: "voteStateVoteTypeFilter",
        filterKey: "state_vote_type",
        trueText: "Committee",
        falseText: "Floor",
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

export class VoteIssueFilter extends Component {
    static get defaultProps() {
        return {
            filterComponent: searchifySelectGenericFilter,
            uniqueFilterId: "voteIssueFilter",
            filterKey: "issue",
            dataTypeLabel: "Issues",
            searchifyFLV: IssueSearchifyFLV,
            selectComponent: IssueSelect,
        }
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

export class VoteDatePickerStartFilter extends Component {
    static defaultProps = {
        filterComponent: datePickerGenericFilter,
        uniqueFilterId: "voteStartDate",
        filterKey: "created__gt",
        displayLabel: "Vote Date After",
        helpText: "Votes scheduled after date selected. Excludes date selected.",
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

export class VoteDatePickerEndFilter extends Component {
    static defaultProps = {
        filterComponent: datePickerGenericFilter,
        uniqueFilterId: "voteEndDate",
        filterKey: "created__lt",
        displayLabel: "Vote Date Before",
        helpText: "Votes scheduled before date selected. Excludes date selected.",
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

export const VoteVoiceVoteFilter = (props) => {
    const FilterComponent = props.filterComponent || toggleGenericFilter
    return <FilterComponent {...props} />
}
VoteVoiceVoteFilter.propTypes = {
    filterComponent: PropTypes.func,
    uniqueFilterId: PropTypes.string,
    filterKey: PropTypes.string,
    displayLabel: PropTypes.string,
    trueText: PropTypes.string,
    falseText: PropTypes.string,
}
VoteVoiceVoteFilter.defaultProps = {
    filterComponent: toggleGenericFilter,
    uniqueFilterId: "voteVoiceVoteFilter",
    filterKey: "voice_vote",
    displayLabel: "Voice Vote",
    trueText: "Yes",
    falseText: "No",
}
